import DefaultLayout from "../components/layout/DefaultLayout.jsx";
import PageMetadata from "../components/layout/PageMetadata.jsx";
import CardGrid from "../components/content-blocks/CardGrid.jsx";
import CardContainer from "../components/content-blocks/CardContainer.jsx";
import "./Home.css";
import introPhoto from "../assets/photos/introduction_card_photo.avif"
import piRunnerAnimation from "../assets/animations/pi-runner-game.webp";

function Home() {
    return (
        <>
            <PageMetadata 
                    title="Study Corner"
                    description="A collection of tools for students to set yearly hierarchical goals and do dopamine-detox with cozy vibes"
                    canonical="https://studycorner.cc/"
                    og={{
                        title: "Study Corner",
                        description: "Your Cozy and Relaxing Corner for Studying",
                        url: "https://studycorner.cc/",
                        type: "website"
                    }}
                    schema={{
                        "@context": "https://schema.org",
                        "@type": "SoftwareApplication",
                        "name": "Study Corner",
                        "applicationCategory": "ProductivityApplication",
                        "operatingSystem": "Web",
                        "url": "https://studycorner.cc/",
                        "description": "Your Cozy and Relaxing Corner for Studying"
                    }}
                />
            <DefaultLayout>
                <CardGrid rows = {5}>
                    <CardContainer className="intro-card">
                        <div className="intro-image-and-text-container">
                            <img src={introPhoto} alt="Introduction" className="intro-card-photo"/>
                            <div className="intro-card-text">
                                <h1>Your Cozy and Relaxing Corner for Studying</h1>
                                <p>
                                    This website is a collection of tools and resources designed to help students plan and visualize goals more effectively, 
                                    and take a break from overstimulating today's lifestyle, a.k.a. dopamine detox, 
                                    all while motivating you all to study new languages and for example hundreds of digits of Pi (🤣) in a different way!
                                    <br/><br/>
                                    Stay tuned for new updates, and <a href="/email-reminder">let me notify you when we launch new features</a>
                                </p>
                            </div>
                        </div>
                    </CardContainer>
                    <CardContainer className="pi-runner-card">
                        <h2>Pi Runner game is here!</h2>
                        <div>
                            <a href="/pi-runner">
                                <img src={piRunnerAnimation} alt="Pi Runner game animation" />
                            </a>
                            <p>
                                The first version of Pi Runner game is online now. The game is simple - type digits of Pi to make blocks in front 
                                of the running character solid. So.. easy.. just 3.14.. ehh.. which ones go after 14? Okay maybe it's not that 
                                easy after all 😅.
                                <br/>
                                In the upcoming version of the game we will be adding global leaderboard as well, to make it more interesting.
                                <br/>
                                How many digits of Pi can you memorize? Find out <a href="/pi-runner">here.</a>
                                <br/><br/> 
                                Currently the Guinness world record for most Pi digits memorized goes to 
                                <a href="https://www.guinnessworldrecords.com/world-records/most-pi-places-memorised"> Rajveer Meena </a> 
                                - astonishing 70 000 digits!
                                <br/>
                            </p>
                        </div>
                    </CardContainer>
                    <CardContainer className="b2">
                        <h2 className="coming-soon-text">Coming soon...</h2>
                    </CardContainer>
                    <CardContainer className="b3">
                        <h2 className="coming-soon-text">Coming soon...</h2>
                    </CardContainer>
                </CardGrid>
            </DefaultLayout>
        </>
    );
}

export default Home;